var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-layout',{staticClass:"shadow-2",attrs:{"view":"lHh lpr lFf"}},[_c('sticky-app-header'),_c('q-page-container',[_c('q-page',[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }